<template>
  <div :class="{ 'upload-files': true, 'view-mode': viewmode }">
    <input
      style="display: none"
      @change="handleFileChange"
      type="file"
      ref="inputfiles"
      multiple
      name="input-file"
      id="input-file"
      hidden
    />
    <el-row type="flex" justify="start" align="middle" style="flex-wrap: wrap">
      <file-button
        v-for="(f, idx) in fileList"
        :key="f.url"
        :filename="f.name"
        :url="f.url"
        :showRemove="!viewmode"
        @remove="onFileRemove(f, idx)"
        @click="(fileUrl) => onFileClick(f, idx, fileUrl)"
        @imgclick="(imgUrl) => onImgClick(f, idx, imgUrl)"
      />
      <div
        class="upload-box"
        @click="onUploadFileClick"
        v-if="fileList.length < limit && !viewmode"
        :title="accetpTitle"
      >
        <i class="el-icon-plus" />
        <div class="file-name">
          <b>上传文件</b>
          <span class="text-danger">(余{{ limit - fileList.length }})</span>
        </div>
      </div>
    </el-row>
    <div v-if="!viewmode" class="warn-box">{{ accetpTitle }}</div>
  </div>
</template>

<script>
import FileButton from "@/components/FileButton";
import { PostFile } from "@/api/general-api";

export default {
  name: "UploadFiles",
  components: { FileButton },
  data() {
    return {
      // --已经上传的文件列表
      fileList: [],
      // --最大文件数限制:如果设置为1则为单文件上传，最小值为1
      limit: 8,
      accetpTitle: ''
    };
  },
  props: {
    category: {
      type: String,
      default: () => "Public",
    },
    action: {
      type: String,
      default: () => "add",
    },
    files: {
      type: Array,
      default: () => [],
    },
    max: {
      type: Number,
      default: () => null,
    },
    viewmode: {
      type: Boolean,
      default: () => false
    },
    acceptFileTypes: {
      type: Array,
      default: () => ['PNG', 'JPG', 'GIF', 'JPEG', 'PDF']
    }
  },
  mounted() {
    if (this.max) {
      this.limit = this.max;
    }
    this.fileList = [...this.files];
    console.log('fileList', this.fileList)
    this.accetpTitle = '只能上传 [' + this.acceptFileTypes.join(',') + '] 文件！'
  },
  methods: {
    isImg(filename) {
      const tmp = filename.split(".").pop().toUpperCase();
      return ["BMP", "JPG", "JPEG", "PNG", "GIF"].includes(tmp);
    },
    // --验证是否为允许上传的文件
    validFileExtension(file) {
      const extension = file.name.split(".").pop().toUpperCase();
      const ya = this.acceptFileTypes.includes(extension)
      if (!ya) {
        this.$message.error(extension + '类型的文件被忽略！')
      }
      return ya
    },
    handleFileChange(e) {
      // -- 还能上传的数量
      let canUploadCount = this.limit - this.fileList.length;
      const files = e.target.files;
      if (files.length) {
        const postRequestArray = [];
        Object.keys(files).forEach((key) => {
          const file = files[key];
          if (this.validFileExtension(file)) {
            if (canUploadCount > 0) {
              postRequestArray.push(
                PostFile(this.category, file)
              );
              canUploadCount -= 1;
            }
          }
        });
        this.$loading.Open("文件上传中...");
        Promise.all(postRequestArray)
          .then((resArray) => {
            this.$loading.Close();
            resArray.forEach((res) => {
              if (res.success && res.data.length) {
                this.fileList.push({
                  ...res.data[0],
                  url: res.data[0].url,
                });
              } else {
                this.$message.error(res.msg);
              }
            });
            this.$emit("filelist-change", this.fileList);
          })
          .catch((error) => {
            this.$loading.Close();
            this.$message.error("文件上传失败：", error);
          });
      }
    },
    onUploadFileClick() {
      const inputFileEle = this.$refs.inputfiles;
      inputFileEle.click();
    },
    onFileRemove(f, idx) {
      this.fileList.splice(idx, 1);
      this.$emit("filelist-change", this.fileList);
    },
    onFileClick(f, idx, fileUrl) {
      console.log('onFileClick', fileUrl)
      const url = fileUrl.toUpperCase().startsWith('HTTP') ? fileUrl : process.env.VUE_APP_BASE_API + fileUrl
      const extension = fileUrl.split(".").pop().toUpperCase()
      if (extension === 'PDF') {
        window.open(url, '_blank')
      } else {
        const a = document.createElement('a')
        a.download = url
        a.href = url
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }

    },
    getUrl(url) {
      return url.toUpperCase().startsWith('HTTP') ? url : process.env.VUE_APP_BASE_API + url
    },
    onImgClick(f, idx, imgUrl) {
      console.log('onImgClick',f, idx, imgUrl)
      const imgList = this.fileList
        .filter((file) => this.isImg(file.url))
        .map((file) => this.getUrl(file.url));
      const index = imgList.findIndex((u) => u === this.getUrl(imgUrl));
      this.$preview(imgList, index);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-files {
  width: 100%;
  padding: 1px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  margin-bottom: 10px;
  &.view-mode {
    border: 0px solid #dcdfe6;
  }
  .upload-box {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    min-width: 50px;
    min-height: 50px;
    height: 110px;
    width: 110px;
    margin: 5px;
    padding: 5px;
    flex-direction: column;
    background-color: #fafafa;
    color: #454545;
    transition: all 0.3s linear;

    &:hover {
      color: #2196f3;
    }

    i {
      font-size: 36px;
    }
    .file-name {
      font-size: 12px;
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      line-height: 16px;
    }
  }
  .warn-box {
    font-size: 11px;
    font-weight: 600;
    color: #dc3545;
    line-height: 12px;
    padding: 2px 3px;
  }
}
</style>